import cx from "classnames";
import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import type { VoterInfo } from "@/appInterface/windows/VoteWindow/VoteResults/types";
import { generateColor } from "@/helpers/generateColor";
import { getInitials } from "@/helpers/getInitials";
import { Check, ChevronDownIcon, ChevronUpIcon } from "@/icons";
import style from "./VoteProgress.module.scss";

type VoteProgressProps = {
    progress: {
        membersVoteCount: number;
        fullyVotedMembersCount: number;
    };
    isOpen: boolean;
    onToggle: () => void;
    voters: VoterInfo[];
};

export const VoteProgress = ({ progress, isOpen, onToggle, voters }: VoteProgressProps) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={style.progress} onClick={onToggle}>
                <div className={style.progressTitle}>
                    <span className={style.progressTitleText}>{t("vote.voted")}</span>

                    <span className={style.progressCounter}>
                        {progress.fullyVotedMembersCount}/{progress.membersVoteCount}
                    </span>

                    <div style={{ marginLeft: "auto" }}>
                        {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    </div>
                </div>

                <div
                    className={style.progressBar}
                    style={
                        {
                            "--width": `${
                                (progress.fullyVotedMembersCount / progress.membersVoteCount) * 100
                            }%`,
                        } as CSSProperties
                    }
                />
            </div>

            {isOpen && (
                <div className={style.dropdown}>
                    {voters.map((voter) => (
                        <div key={voter.token} className={cx(style.dropdownItem, "scrollable")}>
                            <div
                                className={style.avatar}
                                style={{
                                    backgroundColor: generateColor(voter.token),
                                }}
                            >
                                {getInitials(voter.accountName)}
                            </div>
                            <div className={style.dropdownName}>{voter.accountName}</div>
                            <div className={style.icon}>{voter.voted && <Check />}</div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};
